exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-dialog .el-dialog__header {\n  text-align: center;\n  background-color: #409EFF;\n  /* 自定义表头背景色 */\n}\n.custom-dialog .el-dialog__header .el-dialog__title {\n  color: white;\n}\n.custom-dialog .el-dialog__headerbtn {\n  display: none;\n}\n", ""]);

// exports
